import { useController, type FieldValues, FieldPath } from 'react-hook-form';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useIsFieldRevertEnabled } from '../FieldRevert/FieldRevertContext';
import { FieldRevertRow } from '../_components/FieldControlInputContainer/FieldRevertRow';
import { PasswordField } from '../PasswordField/PasswordField';
import { ITextFieldControlProps } from './TextFieldControl.interface';

export const CompactTextFieldControl = <T extends FieldValues, TName extends FieldPath<T>,>(props: ITextFieldControlProps<TName>) => {
  const {
    name, label, type, readOnly, required,
  } = props;

  const {
    field,
    fieldState: { invalid, error },
  } = useController<T, TName>({
    name,
    disabled: readOnly,
  });

  const TextFieldComponent = type === 'password' ? PasswordField : TextField;
  const isRevertEnabled = useIsFieldRevertEnabled();

  const input = (
    <TextFieldComponent
      {...field}
      id={name}
      label={label}
      type={type}
      required={required}
      helperText={error?.message}
      error={invalid}
    />
  );

  if (!isRevertEnabled) {
    return input;
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    }}>
      <FieldRevertRow name={name}>{input}</FieldRevertRow>
    </Box>
  );
};
